import * as types from "@/store/constants/types";
import * as status from "@/store/constants/status";
export default {
  [types.ADD_USER_STATUS](state: any, payLoad: any) {
    const newUserStatus = {
      userId: payLoad,
      status: status.NORMAL, // gx的状态管理
      insStatus: status.NORMAL, //ins的状态管理
      hitCount: {
        follow: {
          count: 0,
          hitStartTimeStamp: null
        },
        like: {
          count: 0,
          hitStartTimeStamp: null
        },
        comment: {
          count: 0,
          hitStartTimeStamp: null
        }
      },
      limitedEndTimeStamp: null //限制用户的结束时间戳
    };
    const findIndex = state.userStatusList.findIndex((user: any) => {
      return user.userId.toString() === payLoad.toString();
    });
    if (findIndex === undefined || findIndex === -1) {
      state.userStatusList.push(newUserStatus);
    } else {
      //如果是重复登陆的 需要更新他的insStatus:
      const newStatus = {
        ...state.userStatusList[findIndex],
        insStatus: status.NORMAL
      };
      state.userStatusList.splice(findIndex, 1, newStatus);
    }
  },
  [types.UPDATE_USER_STATUS](state: any, payLoad: any) {
    const findIndex = state.userStatusList.findIndex((user: any) => {
      return user.userId.toString() === payLoad.userId.toString();
    });
    if (findIndex !== undefined && findIndex !== -1) {
      //采取merge操作：
      state.userStatusList.splice(findIndex, 1, {
        ...state.userStatusList[findIndex],
        ...payLoad
      });
    }
  }
};
